import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PermissionsService } from 'src/app/services/permissions.service';


@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [CommonModule],
})
export class LoginComponent {

  private msalInstance: any;
  errorMessage: string | null = null; 
  email: string = ''
  accessToken: string = ''
  refreshToken: string = ''

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: object, private authService: AuthService, private permissionsService: PermissionsService) {
    if (isPlatformBrowser(this.platformId)) {
      const redirectUri =
        window.location.hostname === 'localhost'
          ? 'http://localhost:4200'
          : 'https://exam.alarkkan.app/';
  
          this.msalInstance = new (window as any).msal.PublicClientApplication({
            auth: {
              clientId: '452de7c2-9769-421d-8464-e6ee604e9476',
              authority: 'https://login.microsoftonline.com/aea9bf80-445f-43cc-8647-909b918e8cf7',
              redirectUri: redirectUri,
            },
            cache: {
              cacheLocation: 'sessionStorage',
              storeAuthStateInCookie: true,
            },
          });
    }
  }
  

  loginWithMicrosoft() {
    if (isPlatformBrowser(this.platformId) && this.msalInstance) {
      const loginRequest = { scopes: ['User.Read', 'email'] };
      this.msalInstance.loginRedirect(loginRequest);
    }
  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId) || !this.msalInstance) return;
  
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    const accounts = this.msalInstance.getAllAccounts();
  
    if (isLoggedIn && accounts.length > 0) {
      const account = accounts[0];
      this.email = account.username;
  
      const keys = Object.keys(sessionStorage);
      keys.forEach((key) => {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
          try {
            const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.credentialType === 'RefreshToken') {
              this.refreshToken = parsedValue.secret;
              this.setUserId();
            }
          } catch (e) {}
        }
      });

      this.msalInstance.acquireTokenSilent({
        scopes: ['User.Read'],
        account: account
      }).then((tokenResponse: any) => {
        this.accessToken = tokenResponse.accessToken;
  
        this.authService.checkUserPermissions(this.email, this.accessToken, this.refreshToken).subscribe((response) => {
          if (response.result[0][0].Permissions && response.result[0][0].Permissions.trim() !== '') {
            this.setUserId();
            this.router.navigate(['/dashboard']);
          } else {
            this.errorMessage = 'You don\'t have Permissions!';
          }
        });
      }).catch(() => {
        this.msalInstance.loginRedirect({ scopes: ['User.Read'] });
      });
  
      return;
    }
 
    this.msalInstance
      .handleRedirectPromise()
      .then((response: any) => {
        if (response && response.account) {

          this.email = response.account.username;
          this.accessToken = response.accessToken;
  
          const keys = Object.keys(sessionStorage);
          keys.forEach((key) => {
            const value = sessionStorage.getItem(key);
            if (value !== null) {
              try {
                const parsedValue = JSON.parse(value);
                  if (parsedValue && parsedValue.credentialType === "RefreshToken") {
                    this.refreshToken = parsedValue.secret
                }
                } catch (e) {
                }
            }
          });
  
          this.authService.checkUserPermissions(this.email, this.accessToken, this.refreshToken).subscribe((response) => {
            if (response.result[0][0].Permissions && response.result[0][0].Permissions.trim() !== '') {
              sessionStorage.setItem('isLoggedIn', 'true');
              this.setUserId();
              this.router.navigate(['/dashboard']);
            } else {
              this.errorMessage = 'You don\'t have Permissions!';
            }
          });
        }
      })
      .catch((error: any) => {
        console.error('MSAL Authentication Error:', error);
      });
  }

  setUserId(){
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        try {
          const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.authorityType === "MSSTS") {
              this.permissionsService.getUserPermissions(parsedValue.username).subscribe((response) => {
                const matchedUser = response.result[0].find((user: { Email: any; }) => user.Email === parsedValue.username);
                if (matchedUser) {
                  this.permissionsService.setUserId(matchedUser.UserID)
                }
              })
          }
          } catch (e) {
          }
      }
    });
  }
  
}
